import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { InputNumbersOnlyDirectiveSharedModule } from '@shared/core/directives/inputNumbersOnly/input-numbers-only.directive.shared.module';
import { CellVerifyComponent } from './cell-verify.shared.component';

@NgModule({
    declarations: [
        CellVerifyComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        InputNumbersOnlyDirectiveSharedModule,
    ],
    exports: [
        CellVerifyComponent
    ],
    providers: [],
})
export class CellVerifyModule { }
